
<template>
  <el-form-item :label="params.label">
    <el-upload
      class="avatar-uploader"
      :action="'/api/upload/commonUpload?selfAreaId=' + selfAreaId"
      :data="{ type: 'id_front_card' }"
      :headers="{ Authorization: authorization }"
      :show-file-list="false"
      :on-success="
        (res, file) => {
          return handleHeadSuccess(res, file, 'code');
        }
      "
      :on-remove="
        (res, file) => {
          return handleImgRemove(res, file, 'code');
        }
      "
      :before-upload="beforeAvatarUpload"
      :on-preview="handlePictureCardPreview"
    >
      <img v-if="value.code" :src="value.code | filterImage" class="avatar" />
      <template v-else>
        <i class="el-icon-plus avatar-uploader-icon"></i>
        <span class="avatar-uploader-text">车辆二维码</span>
      </template>
    </el-upload>
    <el-upload
      class="avatar-uploader"
      :action="'/api/upload/commonUpload?selfAreaId=' + selfAreaId"
      :data="{ type: 'id_back_card' }"
      :headers="{ Authorization: authorization }"
      :show-file-list="false"
      :on-success="
        (res, file) => {
          return handleHeadSuccess(res, file, 'near');
        }
      "
      :on-remove="
        (res, file) => {
          return handleImgRemove(res, file, 'near');
        }
      "
      :before-upload="beforeAvatarUpload"
      :on-preview="handlePictureCardPreview"
    >
      <img v-if="value.near" :src="value.near | filterImage" class="avatar" />
      <template v-else>
        <i class="el-icon-plus avatar-uploader-icon"></i>
        <span class="avatar-uploader-text">带车牌近景照</span>
      </template>
    </el-upload>
    <el-upload
      class="avatar-uploader"
      :action="'/api/upload/commonUpload?selfAreaId=' + selfAreaId"
      :data="{ type: 'id_back_card' }"
      :headers="{ Authorization: authorization }"
      :show-file-list="false"
      :on-success="
        (res, file) => {
          return handleHeadSuccess(res, file, 'far');
        }
      "
      :on-remove="
        (res, file) => {
          return handleImgRemove(res, file, 'far');
        }
      "
      :before-upload="beforeAvatarUpload"
      :on-preview="handlePictureCardPreview"
    >
      <img v-if="value.far" :src="value.far | filterImage" class="avatar" />
      <template v-else>
        <i class="el-icon-plus avatar-uploader-icon"></i>
        <span class="avatar-uploader-text">违规远景照</span>
      </template>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-form-item>
</template>

<script>
import { mapGetters } from "vuex";
import { filterImage } from "@/utils/tools";
export default {
  name: "form-upload",
  props: {
    params: {
      type: Object,
    },
    rowData: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(["selfAreaId", "authorization"]),
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      value: this.rowData
        ? this.rowData[this.params.key]
          ? this.rowData[this.params.key]
          : this.params.value
        : {},
      options: [],
    };
  },
  methods: {
    filterImage,
    reset() {
      if (this.params.dValue) {
        this.radio = this.params.dValue;
      } else {
        this.radio = undefined;
      }
    },
    getValue() {
      if (this.value) {
        return {
          [this.params.key]: Object.values(this.value),
        };
      }
      return [];
    },
    beforeAvatarUpload(file) {
      const isJPG = ["image/jpeg", "image/png"].includes(file.type);
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      return isJPG;
    },
    handleHeadSuccess(res, file, key) {
      this.$set(this.value, key, res.data.path);
    },
    handleImgRemove(file, fileList, key) {
      this.$set(this.value, key, "");
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
  watch: {
    value(nv, ov) {
      const cp = {...this.params};
      cp.value = Object.values(nv);
      this.$emit("csi", cp);
    },
  },
};
</script>

<style lang="less" scoped>
.avatar-uploader {
  display: inline-block;
  margin-right: 10px;
}

.avatar-uploader /deep/.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  &:hover {
    border-color: #409eff;
  }
}

.avatar-uploader-icon {
  font-size: 21px;
  color: #8c939d;
  width: 112px;
  height: 112px;
  line-height: 112px;
  text-align: center;
  color: rgba(0, 0, 0, 0.25);
}

.avatar-uploader-text {
  position: absolute;
  bottom: 18px;
  left: 50%;
  color: rgba(0, 0, 0, 0.65);
  transform: translateX(-50%);
  text-align: center;
  width: 100%;
  font-size: 12px;
  line-height: 1em;
  font-family: PingFangSC-Regular, PingFang SC;
}

.avatar {
  width: 112px;
  height: 112px;
  display: block;
}
</style>
